/**
 * Naive implementation of a pluralise function for english
 */
export function pluralise(noun: string, count: number) {
  if (count === 1) {
    return noun;
  }

  // Ends with s
  if (/s$/i.test(noun)) {
    return `${noun}es`;
  }

  // Ends with [vowel]y
  if (/[aeiou]y$/i.test(noun)) {
    return `${noun}s`;
  }

  // Ends with [consonant]y
  if (/y$/i.test(noun)) {
    return `${noun.slice(0, -1)}ies`;
  }

  return `${noun}s`;
}

export function captialise(word: string) {
  if (word[0] === void 0) {
    return "";
  }

  return word[0].toUpperCase() + word.slice(1);
}

export enum Case {
  KebabCase = "kebab-case",
  PascalCase = "PascalCase",
  CamelCase = "camelCase",
  SnakeCase = "snake_case",
  ScreamingSnakeCase = "SCREAMING_SNAKE_CASE",
  SentenceCase = "Sentence case",
  TitleCase = "Title Case",
}

export function words(str: string, casing: Case): string[] {
  switch (casing) {
    case Case.KebabCase:
      return str.split("-");
    case Case.PascalCase:
    case Case.CamelCase:
      return str.replace(/([^A-Z])([A-Z])/g, "$1🌈$2").split("🌈");
    case Case.SnakeCase:
    case Case.ScreamingSnakeCase:
      return str.split("_");
    case Case.SentenceCase:
    case Case.TitleCase:
      return str.split(" ");
  }
}
export function convertCase(str: string, from: Case, to: Case) {
  const parts = words(str, from);

  switch (to) {
    case Case.KebabCase:
      return parts.map((s) => s.toLowerCase()).join("-");
    case Case.PascalCase:
    case Case.CamelCase:
      return parts
        .map((s, i) => (i > 0 || to === Case.PascalCase ? captialise(s) : s))
        .join("");
    case Case.SnakeCase:
    case Case.ScreamingSnakeCase:
      return parts
        .map((s) => s[to === Case.SnakeCase ? "toLowerCase" : "toUpperCase"]())
        .join("_");
    case Case.SentenceCase:
    case Case.TitleCase:
      return parts
        .map((s, i) => (i === 0 || to === Case.TitleCase ? captialise(s) : s))
        .join(" ");
  }
}
